<script setup>
 import SearchClaimsComponent from "@/Components/Claims/SearchClaimsComponent.vue";
 import {Permissions} from "@/Utils/Permissions";
</script>

<template>
  <v-container fluid>
    <v-row v-if="Permissions.checkPermissions(['claims.search'])">
      <v-col cols="12">
        <SearchClaimsComponent/>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>

</style>